import { Stack, Text } from '@ltvco/refresh-lib/theme';

import { BaseCardComponent } from './BaseCardComponent';

interface CulturalFunFactsProps {
  culturalFunFacts?: string[];
}

export function CulturalFunFacts({ culturalFunFacts }: CulturalFunFactsProps) {
  return (
    <BaseCardComponent title="Cultural Fun Facts">
      <Stack spacing={2} alignItems="flex-start">
        {culturalFunFacts?.map((fact) => (
          <Text key={fact} variant="body2">
            {fact}
          </Text>
        ))}
      </Stack>
    </BaseCardComponent>
  );
}
